<template>
  <b-modal
    size="xl"
    hide-footer
    id="modal-calculVaseExpansion"
    title="Calcul vase d'expansion"
  >
    <b-row class="mb-2">
      <b-button v-if="calculVaseExpansion.length < 2" @click="seed()">
        SEED
      </b-button>
      <!-- <b-button  @click="unlock()">
            <b-icon icon="lock-fill" aria-hidden="true"></b-icon>
        </b-button> -->
      <b-col sm="12">
        <b-card bg-variant="light">
          <div v-for="(item, index) in calculVaseExpansion" :key="item.id">
            <b-input-group
              :label="item.name"
              label-for="nested-diagnostic"
              label-cols-sm="3"
              label-align-sm="right"
              class="mb-2"
            >
              <b-input-group-prepend is-text>
                {{ item.id }}
              </b-input-group-prepend>
              <b-col cols="7">
                <b-form-input
                  v-model="item.name"
                  placeholder="Nom"
                  debounce="300"
                  :disabled="index <= 9"
                  @update="saveVaseExpansion(item)"
                  required
                ></b-form-input>
              </b-col>
              <b-col>
                <b-form-input
                  v-model="item.value"
                  placeholder="Valeur"
                  debounce="300"
                  :disabled="index <= 9"
                  @update="saveVaseExpansion(item)"
                  v-if="item.isFix"
                  required
                ></b-form-input>
              </b-col>
              <b-col>
                <b-form-input
                  v-model="item.unit"
                  placeholder="Unité"
                  debounce="300"
                  :disabled="index <= 9"
                  @update="saveVaseExpansion(item)"
                  required
                ></b-form-input>
              </b-col>
              <b-input-group-append is-text>
                <input
                  type="checkbox"
                  v-model="item.isFix"
                  :disabled="index <= 9"
                  @update="saveVaseExpansion(item)"
                />
              </b-input-group-append>
            </b-input-group>
            <b-button
              v-if="calculVaseExpansion.length === index + 1"
              disabled
              block
              @click="addSpec()"
              class="mt-3 mb-3"
              type="submit"
              variant="primary"
            >
              Ajouter

            </b-button>
          </div>
        </b-card>
        <b-card bg-variant="light">
          <p>Pression de gonflage du vase - bar - Pgonflage = Hauteur statique(4)/10+Pression minimale(2)-0,5</p>
          <p>Pression de remplissage du circuit à froid - bar - Pression de remplissage = Hauteur statique(4)/10+Pression minimale(2) </p>
          <p>Volume capteurs - litres - Volume capteurs = nb de capteurs(5) x Surface capteurs(7) x contenance capteurs(6) </p>
          <p>Volume tuyauteries - litres - Volume tuyauterie = longueur(8) x PI x rayon² (diamètre:9)</p>
          <p>Volume du réseau - litres -  Volume réseau = Volume capteurs + Volume tuyauteries + Volume échangeur </p>
          <p>Volume de dilatation - litres - Volume dilatation = Volume du réseau/1000 * x coefficient de dilatation(3) </p>
          <p>Volume de réserve - litres - Volume réseau = Volume capteurs + Volume tuyauteries + Volume échangeur </p>
          <p>Pression finale - bar - Pfinale = Pression tarage soupape(10) x 0,9</p>
          <p>Volume utile - litres - Vutile = 1,1 x volume capteurs + Vdilatation + Vréserve </p>
          <p>Facteur de pression de vase - Facteur de pression = (Pression finale - Pression de gonflage du vase)/(Pression finale+1) </p>
          <h4>Volume vase - litres - Volume vase = Vutile/Facteur de pression de vase x 1,5</h4>
        </b-card>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
// require("json-circular-stringify");

export default {
  name: "ModalCalculVaseExpansion",
  data() {
    return {
      calculVaseExpansion: [
        {
          id: "",
          name: "",
          value: "",
          unit: "",
          isFix: "",
        },
      ],
      typologies: [],
      isLoading: false,
      edit: false,
      disabled: false,
      datasSeed: [
        {
          id: 1,
          name: "Volume échangeur",
          value: "10",
          unit: "l",
          isFix: true,
          key: "vEchangeur"
        },
        {
          id: 2,
          name: "Pression minimale (Pmin)",
          value: null,
          unit: "bar",
          isFix: true,
          key: "Pmin"
        },
        {
          id: 3,
          name: "Coefficient de dilatation du fluide à 40 %, 120°C",
          value: 73,
          unit: "l/m3",
          isFix: true,
          key: "coefDilatation"
        },
        {
          id: 4,
          name: "Hauteur statique (ou manométrique) de l'installation (H)",
          value: null,
          unit: "m",
          isFix: false,
          key: "H"
        },
        // {
        //   id: 5,
        //   name: "Nombre de capteurs",
        //   value: null,
        //   unit: "",
        //   isFix: false,
        //   key: "nbreCapteur"
        // },
        // {
        //   id: 6,
        //   name: "Contenance capteurs",
        //   value: null,
        //   unit: "l/m2",
        //   isFix: false,
        //   key: "contenanceCapteurs"
        // },
        // {
        //   id: 7,
        //   name: "Surface d'un capteur",
        //   value: null,
        //   unit: "m2",
        //   isFix: false,
        //   key: "surfaceCapteur"
        // },
        {
          id: 8,
          name: "Longueur tuyauterie",
          value: null,
          unit: "m2",
          isFix: false,
          key: "longuerTuyau"
        },
        {
          id: 9,
          name: "Diamètre intérieur tuyauterie",
          value: null,
          unit: "mm",
          isFix: false,
          key: "diametreTuyau"
        },
        {
          id: 10,
          name: "Pression de tarage de la soupape",
          value: null,
          unit: "bar",
          isFix: false,
          key: "Ptarage"
        },
      ],
    };
  },
  components: {},
  mounted() {
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      if (modalId === "modal-calculVaseExpansion") {
        this.getCalculVaseExpansion();
      }
    });
    this.$root.$on("bv::modal::hidden", (bvEvent, modalId) => {
      if (modalId === "modal-calculVaseExpansion") {
        this.calculVaseExpansion = [];
      }
    });
  },
  methods: {
    seed() {
      // Restart id from 1 in db if it doesn't
      // TRUNCATE TABLE public."vaseExpansions" RESTART IDENTITY;
      for (const item of this.datasSeed) {
        this.saveVaseExpansion(item);
      }
    },
    getCalculVaseExpansion() {
      fetch(
        process.env.VUE_APP_API_BASE_URL +
          "/api/v1/vase/getCalculVaseExpansion",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`
          },
        }
      )
        .then((res) => res.json())
        .then((rep) => {
          if (rep.length > 0) {
            this.calculVaseExpansion = rep.sort((a, b) => a.id - b.id);
          }
        });
    },
    saveVaseExpansion(item) {
      console.log(item);
      this.isLoading = true;

      fetch(
        process.env.VUE_APP_API_BASE_URL + "/api/v1/vase/saveVaseExpansion",
        {
          method: "POST",
          body: JSON.stringify(item),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`
          },
        }
      )
        .then((res) => res.json())
        .then((rep) => {
          this.isLoading = false;
          console.log(rep);
          item = rep;
          this.success = true;
          this.getCalculVaseExpansion();
        });
    },
    updateInput() {},
    addSpec() {
      this.calculVaseExpansion.push({
        name: "",
        value: "",
        unit: "",
        type: "",
      });
    },
    unlock() {},
  },
};
</script>
<style></style>
